import styled from 'styled-components/macro';

import { chatUI } from 'styles/featureColors/chatUIColors';
import { ActionButton } from '../ChatUI.styles';

export const RecommendationContainer = styled.div`
  height: 100%;
  padding: 0px;
  z-index: 0;
  display: flex;
  flex-direction: row;
  justify-content: space-between;

  animation-name: fadeIn;
  animation-duration: 0.5s;
  animation-fill-mode: forwards;

  @keyframes fadeIn {
    0% {
      opacity: 0%;
    }
    100% {
      opacity: 100%;
    }
  }
`;

export const LeftSideContainer = styled.div`
  display: flex;
  flex-direction: row;
  ${(props) => (props.prevProductRecs ? 'width: 100%' : 'width: 416px')};
  overflow: hidden;
  padding-left: 20px;
`;

export const ProductsImgWrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  overflow: hidden;
  ${(props) => (props.prevProductRecs ? 'padding-right: 50px' : null)};

  img {
    width: 80px;
  }
`;

export const ProductRecsTextWrapper = styled.div`
  display: flex;
  ${(props) => (props.prevProductRecs ? 'width: 100%' : 'width: 298px')};
  flex-direction: column;
  justify-content: center;
  overflow: hidden;
  padding-left: 18px;

  h4 {
    font: normal 500 11px/17px Roboto;
    margin: 0;
    padding-bottom: 3px;
  }

  p {
    font: normal 400 10px/16px Roboto;
    margin: 0;
  }
`;

/** *** Product Recommendation Buttons *****/

export const RightSideContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 0px 20px;
`;

export const RecommendationsButton = styled(ActionButton)`
  background-color: ${chatUI.buttons.useThis};
  border: 1px solid ${chatUI.content.border};
  color: ${chatUI.buttons.textLight};
  padding: 4px 14.5px;
  width: 122px;
  height: 26px;

  font: normal 400 11px/17px Roboto;
`;
